<script setup lang="ts">
import EventSettingsSwitch from './EventSettingsSwitch.vue'
</script>

<template>
  <EventSettingsSwitch settingName="shotsCoordinates">
    <span class="w-20">Shots coordinates</span>
  </EventSettingsSwitch>
</template>
